import React, {useState} from 'react';
import {Link} from 'react-router-dom'
import {FaBars, FaTimes} from 'react-icons/fa'
import './NavbarStyles.css'
import Logo from '../assets/logo.png'
function Navbar() {
    const[click, setClick] = useState(false)
    const handleClick = () => setClick(!click)


  return (
    <div className='header'>
        
        <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li>
                <Link style={{outlineColor:'black'}} to='/shows'>Shows</Link>
            </li>
            <li>
                <Link to='/shop'>Shop</Link>
            </li>
            <li>
                <Link to='/songs'>Songs</Link>
            </li>
            <li>
                <Link to='/contact'>Contact</Link>
            </li>
        </ul>
        <Link to='/'><img src={Logo}></img></Link>
        <div className='hamburger' onClick={handleClick}>
         {click ? (<FaTimes size={20} style={{color:'#fff'}}/>) : (<FaBars size={20} style={{color:'#fff'}}/>)}    
        </div>
         
    </div>
  )
}

export default Navbar